import { ImageDimensions } from '@/commons/types'
import {
    JPEG_DATA_PREFIX,
    JPEG_START_OF_IMAGE_BYTES,
    BYTES_IN_MB
} from '@/commons/constants/image'

export class ImageUtils {
    static getImageDimensions (file: File): Promise<ImageDimensions> {
        return new Promise<ImageDimensions>((resolve, reject) => {
            const image = new Image()
            image.onerror = error => reject(error)
            image.onload = () => resolve({
                width: image.width,
                height: image.height
            })
            image.src = window.URL.createObjectURL(file)
        })
    }

    static fileToBase64 (file: File): Promise<string | ArrayBuffer | null> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onerror = error => reject(error)
            reader.onload = () => resolve(reader.result)
            reader.readAsDataURL(file)
        })
    }

    static fileToArrayBuffer (file: File): Promise<string | ArrayBuffer | null> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onerror = error => reject(error)
            reader.onload = () => resolve(reader.result)
            reader.readAsArrayBuffer(file)
        })
    }

    static addJpegDataPrefix (image: string): string {
        return image.startsWith(JPEG_DATA_PREFIX) ? image : `${JPEG_DATA_PREFIX}${image}`
    }

    static stripJpegDataPrefix (image: string): string {
        return image.startsWith(JPEG_DATA_PREFIX) ? image.replace(JPEG_DATA_PREFIX, '') : image
    }

    static isImageUrl (imageUrl: string | null | undefined): boolean {
        return imageUrl ? /^data:.+;base64,/.test(imageUrl) : false
    }

    static getImageUrl (base64Image: string | null | undefined): string {
        if (!base64Image) {
            return ''
        }
        return ImageUtils.isImageUrl(base64Image) ? base64Image : `${JPEG_DATA_PREFIX}${base64Image}`
    }

    static getBiometryImageFromUploadedOrExternalSource (
        uploadedImage: string | null | undefined, externalImageSource: string | null | undefined
    ): string | null {
        let image: string | null = uploadedImage || null
        if (!image) {
            image = externalImageSource || null
        }
        return image ? ImageUtils.getImageUrl(image) : null
    }

    static isJpegImage (imageStartBytes: Uint8Array): boolean {
        return JPEG_START_OF_IMAGE_BYTES.every((v, i) => v === imageStartBytes[i])
    }

    static getImageSizeInMb (sizeInBytes: number): number {
        return (sizeInBytes / BYTES_IN_MB)
    }
}
